import React from "react";
import Form from "react-bootstrap/Form";
import { Validator as CFValidator } from "@marketto/codice-fiscale-utils/dist/codice-fiscale-utils";
import { applyFieldChange, isFieldDisabled, isOptionDisabled } from "../utils/registrationFields";

const RegistrationFieldsInput = ({ fields, values, onChange, idPrefix = "registration" }) => {
  const handleChange = (fieldId, value) => {
    onChange(applyFieldChange(fields, values, fieldId, value));
  };

  return (
    <>
      {(fields || []).map((field) => {
        const controlId = `${idPrefix}-${field.id}`;
        const value = values?.[field.id];
        const disabled = isFieldDisabled(fields, values, field);
        if (field.type === "checkbox") {
          return (
            <Form.Group className="mb-3" controlId={controlId} key={field.id}>
              <Form.Check
                type="checkbox"
                required={field.required}
                label={field.label}
                checked={Boolean(value)}
                onChange={(e) => handleChange(field.id, e.target.checked)}
              />
            </Form.Group>
          );
        }
        if (field.type === "textarea") {
          return (
            <Form.Group className="mb-3" controlId={controlId} key={field.id}>
              <Form.Label>{field.label}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                required={field.required}
                value={value || ""}
                onChange={(e) => handleChange(field.id, e.target.value)}
              />
            </Form.Group>
          );
        }
        if (field.type === "select") {
          return (
            <Form.Group className="mb-3" controlId={controlId} key={field.id}>
              <Form.Label>{field.label}</Form.Label>
              <Form.Select
                required={field.required}
                value={value || ""}
                disabled={disabled}
                onChange={(e) => handleChange(field.id, e.target.value)}
              >
                <option disabled value="">
                  Seleziona
                </option>
                {(field.options || []).map((option) => (
                  <option
                    key={option}
                    value={option}
                    disabled={isOptionDisabled(fields, values, field, option)}
                  >
                    {option}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          );
        }
        if (field.type === "codice_fiscale") {
          const compact = String(value || "");
          const valid = compact === "" ? false : CFValidator.codiceFiscale(compact).valid;
          return (
            <Form.Group className="mb-3" controlId={controlId} key={field.id}>
              <Form.Label>{field.label}</Form.Label>
              <Form.Control
                required={field.required}
                type="text"
                autoComplete="off"
                placeholder="Inserisci il codice fiscale"
                value={compact}
                onChange={(e) => handleChange(field.id, e.target.value.toUpperCase())}
                style={{ textTransform: "uppercase" }}
                isValid={compact === "" ? false : valid}
                isInvalid={compact === "" ? false : !valid}
              />
              <Form.Control.Feedback type="invalid">
                Codice fiscale non valido
              </Form.Control.Feedback>
            </Form.Group>
          );
        }
        return (
          <Form.Group className="mb-3" controlId={controlId} key={field.id}>
            <Form.Label>{field.label}</Form.Label>
            <Form.Control
              required={field.required}
              type={field.type === "number" ? "number" : field.type === "date" ? "date" : "text"}
              value={value || ""}
              onChange={(e) => handleChange(field.id, e.target.value)}
            />
          </Form.Group>
        );
      })}
    </>
  );
};

export default RegistrationFieldsInput;
